<template>
  <div class="print-calendars text-dark" id="printCalendars">
    <div class="loader-container" v-if="isLoading">
      <Loader bg-color="#f6f9fc"></Loader>
      <h3>{{ $t('vue2.print_all_calendars.loading') }}</h3>
    </div>
    <template v-else>
      <h2 class="explainer-text italic pad-20" v-if="calendars.length < 1">
        <span>{{ $t('vue2.print_all_calendars.no_calendars') }}</span></h2>
      <div class="d-calendar"
           v-for="calendar in calendars"
           :key="calendar.id">
        <h2 class="text-dark" v-if="theViewSetting !== 'list'">{{ calendar.name }}</h2>
        <div class="calculate-hours-wrapper">
          <CalculateHours
            v-if="isPrintHours"
            class="print-calculate-hours"
            :isShowOptions="false"
            :schoolId="schoolId"
            :calendarId="calendar.id"
            :date="date">
          </CalculateHours>
          <div class="d-calendar__calendar__container d-calendar__calendar__container--print-mode"
               :class="[{'d-calendar__calendar__container--print-mode--is-list': theViewSetting === 'list'}, {'d-calendar__calendar__container--print-mode--is-print-hours': isPrintHours}]">
            <DCalendarPrint
              v-if="theViewSetting === 'blocks'"
              :isCalendarInPrintMode="true"
              :isShowWeekends="isShowWeekends"
              :startTime="startTime"
              :endTime="endTime"
              :date="date"
              :events="calendar.events"
              :calendarId="calendar.id"
              :calendarName="calendar.name"
              :firstDayOfWeek="firstDayOfWeek">
            </DCalendarPrint>
            <DCalendar
              v-if="theViewSetting === 'calendar' || theViewSetting === 'list'"
              :isCalendarInPrintMode="true"
              :isShowWeekends="isShowWeekends"
              :isHideCalendars="isHideCalendars"
              :isHideDates="isHideDates"
              :isCalNoBgColors="isCalNoBgColors"
              :eventFontSize="eventFontSize"
              :startTime="startTime"
              :endTime="endTime"
              :date="date"
              :events="calendar.events"
              :calendarId="calendar.id"
              :calendarName="calendar.name"
              :isShowAsList="theViewSetting === 'list'"
              :firstDayOfWeek="firstDayOfWeek">
            </DCalendar>
          </div>
        </div>
      </div>
    </template>
    <DModal class="modal-print-button" :class="{'modal-print-button--hide': !isShowPrintButton}" :show-close="false"
            v-if="isShowPrintButton">
      <div class="d-modal__content d-modal__print_button" :class="{'d-modal__print_button--wide':showDSelect}" slot="insertComponent">
        <div class="custom-select-calendars" v-if="showDSelect">
          <label class="d-label marg-1-bottom">{{ $t('vue2.print_all_calendars.custom') }}</label>
          <DSelectCals
            :appendToBody="true"
            @updateItems="dSelectCalsUpdated('update', $event)">
          </DSelectCals>
          <div class="custom-select-calendars__submit">
            <button class="do-bttn do-bttn--submit" v-if="!isCalendarsSelected" @click="setIsCalendarsSelected">{{ $t('vue2.common.save') }}</button>
          </div>
        </div>
        <div class="d-modal__print_button__settings" v-show="!showDSelect || isCalendarsSelected">
          <div class="d-input-group marg-1-bottom" style="margin: 0">
            <label class="d-input marg-05-bottom">{{
                $t('vue2.standard_settings.set_default_start_and_endtime')
              }}</label>
            <TimeChanger
              class="marg-1-top"
              :showIcon="true"
              :start="startTimeDate"
              :end="endTimeDate"
              @updateStart="setStartTime"
              @updateEnd="setEndTime">
            </TimeChanger>
          </div>
          <div class="input-group input-group__toggle" @click.stop="changeSetting('isHideDates', !isHideDates)">
            <label class="d-label">{{ $t('vue2.common.hide_dates') }}</label>
            <app-toggle :allowChanges="false" :propOn="isHideDates"></app-toggle>
          </div>
          <div class="input-group input-group__toggle" @click.stop="changeSetting('isShowWeekends', !isShowWeekends)">
            <label class="d-label">{{ $t('vue2.common.show_weekends') }}</label>
            <app-toggle :allowChanges="false" :propOn="isShowWeekends"></app-toggle>
          </div>
          <div class="input-group input-group__toggle" @click.stop="setViewSetting('list')">
            <label class="d-label">{{ $t('vue2.common.show_as_list') }}</label>
            <app-toggle :allowChanges="false" :propOn="theViewSetting === 'list'"></app-toggle>
          </div>
          <div class="input-group input-group__toggle" @click.stop="setViewSetting('blocks')">
            <label class="d-label">{{ $t('vue2.common.show_as_blocks') }}</label>
            <app-toggle :allowChanges="false" :propOn="theViewSetting === 'blocks'"></app-toggle>
          </div>
          <div class="input-group input-group__toggle" @click.stop="changeSetting('isPrintHours', !isPrintHours)">
            <label class="d-label">{{ $t('vue2.common.show_print_hours') }}</label>
            <app-toggle :allowChanges="false" :propOn="isPrintHours"></app-toggle>
          </div>
          <div class="input-group input-group__toggle" @click.stop="changeSetting('isCalNoBgColors', !isCalNoBgColors)"
               v-if="theViewSetting === 'calendar'">
            <label class="d-label">{{ $t('vue2.print_all_calendars.show_print_without_bg_colors') }}</label>
            <app-toggle :allowChanges="false" :propOn="isCalNoBgColors"></app-toggle>
          </div>
          <div class="input-group input-group__toggle" @click.stop="changeSetting('isHideCalendars', !isHideCalendars)">
            <label class="d-label">{{ $t('vue2.common.hide_calendars') }}</label>
            <app-toggle :allowChanges="false" :propOn="isHideCalendars"></app-toggle>
          </div>
          <div class="input-group input-group__toggle" v-if="theViewSetting === 'calendar'">
            <label class="d-label marg-1-right">{{ $t('vue2.print_all_calendars.event_font_size') }}</label>
            <input type="range" name="vol" min="4" max="16" v-model="eventFontSize"
                   @change="changeSetting('eventFontSize', eventFontSize)">
          </div>
          <div class="d-modal__buttons d-modal__print_button__submit"
               :class="{'d-modal__print_button__submit--space': hasUserPrintSettings}">
            <p class="text-link" v-show="hasUserPrintSettings" @click="resetPrintSettings">Nulstil</p>
            <div class="d-modal__print_button__submit--right">
              <button class="marg-1-right do-bttn" @click="close">{{ $t('vue2.common.cancel') }}</button>
              <button class="do-bttn do-bttn--submit" @click="print">{{ $t('vue2.print_all_calendars.print') }}</button>
            </div>
          </div>
        </div>
      </div>
    </DModal>
  </div>
</template>
<script>
import DSelectCals from '../DSelect/DSelectCalsAll.vue'
import DCalendar from '../DCalendar/DCalendar'
import docendo from '../../docendo'
import moment from 'moment'
import Loader from '../common/Loader'
import DModal from '../common/DModal.vue'
import eventbus from '../../eventbus'
import AppToggle from '../common/AppToggle.vue'
import TimeChanger from '../TimeChanger.vue'
import DCalendarPrint from '../DCalendar/DCalendarPrint'
import CalculateHours from '../Calendars/CalculateHours'

export default {
  components: {DSelectCals, CalculateHours, DCalendarPrint, AppToggle, DModal, Loader, DCalendar, TimeChanger},
  props: {
    calendarIds: {
      type: Array,
      default: () => []
    },
    date: {
      default: () => moment().format('YYYY-MM-DD')
    },
    startDate: {
      default: () => moment().isoWeekday(1).format('YYYY-MM-DD 00:00')
    },
    endDate: {
      default: () => moment().isoWeekday(7).format('YYYY-MM-DD 00:00')
    },
    firstDayOfWeek: {
      type: Number,
      default: 1
    },
    showDSelect: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      events: [],
      isLoading: true,
      theViewSetting: 'calendar',
      isShowPrintButton: false,
      isShowWeekends: false,
      isPrintHours: false,
      startTimeDate: moment().set({'hour': 6, 'minutes': 0, 'second': 0, 'millisecond': 0}),
      endTimeDate: moment().set({'hour': 16, 'minutes': 0, 'second': 0, 'millisecond': 0}),
      isCalNoBgColors: false,
      eventFontSize: 10,
      isCalendarsSelected: false,
      isHideCalendars: false,
      isHideDates: false
    }
  },
  watch: {
    isLoading (val) {
      if (!this.isLoading) {
        setTimeout(_ => {
          this.isShowPrintButton = true
        }, 500)
      }
    },
    calendarIds (val) {
      if (this.isCalendarsSelected) {
        this.getEvents()
      }
    }
  },
  computed: {
    schoolId () {
      return this.$store.getters.schoolId
    },
    startTime () {
      return moment(this.startTimeDate).format('HH:mm:ss')
    },
    endTime () {
      return moment(this.endTimeDate).format('HH:mm:ss')
    },
    allCalendarsInHash () {
      return this.$store.getters.allCalendarsInHash
    },
    eventsInHash () {
      let objOfEvents = {}
      if (this.events.length < 1) {
        objOfEvents = {}
      } else {
        this.events.forEach(event => {
          event.calendars.forEach(calendar => {
            let calendarId = calendar.calendar_id
            if (!objOfEvents[calendarId]) {
              this.$set(objOfEvents, calendarId, [event])
            } else {
              objOfEvents[calendarId].push(event)
            }
          })
        })
      }
      return objOfEvents
    },
    calendars () {
      let cals = []
      cals = this.calendarIds.map(calId => {
        return {
          id: calId,
          name: this.allCalendarsInHash[calId] ? this.allCalendarsInHash[calId].name : 'No title',
          view_state: 0,
          events: this.eventsInHash[calId] ? this.eventsInHash[calId] : [],
          isHasEvents: this.eventsInHash[calId]
        }
      })
      return cals.filter(cal => cal.isHasEvents)
    },
    userSettings () {
      return this.$store.state.userSettings
    },
    userPrintSettings () {
      return this.userSettings['print_settings_calendar'] ? this.userSettings['print_settings_calendar'] : {}
    },
    hasUserPrintSettings () {
      return Object.keys(this.userPrintSettings).length > 0
    }
  },
  methods: {
    setIsCalendarsSelected () {
      this.isCalendarsSelected = true
      this.$nextTick(_ => {
        this.getEvents()
      })
    },
    dSelectCalsUpdated (type, cals) {
      this.$emit('updateCalendars', cals)
    },
    updatePrintSettingsFromComputed () {
      Object.keys(this.userPrintSettings).forEach(setting => {
        const val = this.userPrintSettings[setting]
        if (this.hasOwnProperty(setting)) { // Check if the component has the property
          this[setting] = val // Dynamically set the property value
        }
      })
    },
    changeSetting (setting, val) {
      if (this.hasOwnProperty(setting)) { // Check if the component has the property
        this[setting] = val // Dynamically set the property value
        this.savePrintSettings(setting, val)
      }
    },
    savePrintSettings (setting, val) {
      const initPrintSettings = {
        theViewSetting: 'calendar',
        isShowWeekends: false,
        isPrintHours: false,
        startTimeDate: moment().set({'hour': 6, 'minutes': 0, 'second': 0, 'millisecond': 0}),
        endTimeDate: moment().set({'hour': 16, 'minutes': 0, 'second': 0, 'millisecond': 0}),
        isCalNoBgColors: false,
        eventFontSize: 10
      }
      let newPrintSettings = JSON.parse(JSON.stringify(this.userPrintSettings))
      if (initPrintSettings[setting] === val && this.userPrintSettings[setting]) {
        delete newPrintSettings[setting]
        if (Object.keys(newPrintSettings).length === 0) {
          this.$store.dispatch('deleteUserSetting', 'print_settings_calendar')
        } else {
          this.$store.dispatch('updateUserSettings', {'print_settings_calendar': newPrintSettings})
        }
        return
      }
      if (initPrintSettings[setting] !== val) {
        newPrintSettings[setting] = val
        this.$store.dispatch('updateUserSettings', {'print_settings_calendar': newPrintSettings})
      }
    },
    resetPrintSettings () {
      this.theViewSetting = 'calendar'
      this.isShowWeekends = false
      this.isPrintHours = false
      this.startTimeDate = moment().set({'hour': 6, 'minutes': 0, 'second': 0, 'millisecond': 0}).format() // Adjust format as needed
      this.endTimeDate = moment().set({'hour': 16, 'minutes': 0, 'second': 0, 'millisecond': 0}).format() // Adjust format as needed
      this.isCalNoBgColors = false
      this.eventFontSize = 10
      this.$store.dispatch('deleteUserSetting', 'print_settings_calendar')
    },
    setViewSetting (type) {
      if (this.theViewSetting === type) {
        this.theViewSetting = 'calendar'
        this.changeSetting('theViewSetting', 'calendar')
      } else {
        this.theViewSetting = type
        this.changeSetting('theViewSetting', type)
      }
    },
    setStartTime (payload) {
      this.startTimeDate = payload
      this.changeSetting('startTimeDate', payload)
    },
    setEndTime (payload) {
      this.endTimeDate = payload
      this.changeSetting('endTimeDate', payload)
    },
    getEvents () {
      this.isLoading = true
      docendo.eventsFromCalendars(this.calendarIds, this.startDate, this.endDate, null,
        data => {
          this.events = data.length > 0 ? JSON.parse(data) : []
          this.isLoading = false
        }, failure => {
          console.log('failure', failure)
        })
    },
    print () {
      this.isShowPrintButton = false
      this.$nextTick(_ => {
        // https://stackoverflow.com/questions/52343006/how-to-print-a-part-of-a-vue-component-without-losing-the-style
        const prtHtml = document.getElementById('printCalendars').innerHTML
        // Get all stylesheets HTML
        let stylesHtml = ''
        for (const node of [...document.querySelectorAll('link[rel="stylesheet"][href*="/app/static/css/"], style')]) {
          stylesHtml += node.outerHTML
        }
        // Open the print window
        const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')

        WinPrint.document.write(`<!DOCTYPE html><html><head>${stylesHtml}</head><body>${prtHtml}</body></html>`)
        var afterPrint = () => {
          WinPrint.close()
          this.close()
        }
        WinPrint.onafterprint = afterPrint
        setTimeout(_ => {
          WinPrint.document.close()
          WinPrint.focus()
          WinPrint.print()
        }, 1000)
      })
    },
    close () {
      this.isShowPrintButton = false
      eventbus.isPrintCalendarsModal = false
    }
  },
  mounted () {
    this.updatePrintSettingsFromComputed()
    setTimeout(_ => {
      this.getEvents()
    }, 500)
  },
  beforeDestroy () {
    this.$emit('clear')
  }
}
</script>

<style>

.print-calendars {
  width: 90vw;
  height: 90vh;
  overflow-y: auto;
}

.d-calendar {
  background: #ffffff;
}

.loader-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 50px;
}

.loader-container h3 {
  font-style: italic;
  margin-top: -2rem;
}

.d-modal__print_button {
  min-width: 300px;
  max-height: calc(90vh - 6rem);
  overflow-y: auto;
  padding: 3rem 3rem 0 3rem;
  max-width: 80vw;
}

.d-modal__print_button.d-modal__print_button--wide {
  min-width: 600px;
  min-height: 500px;
  max-height: calc(90vh);
}

.d-modal__print_button.modal-print-button--hide {
  display: none;
}

.italic {
  font-style: italic;
}

.d-calendar .fc-event .fc-time {
  float: right;
}

@media print {
  .print-calendars__header,
  .modal-print-button {
    display: none;
  }

  .d-calendar {
    page-break-after: always;
  }
}

.calculate-hours-wrapper {
  display: flex;
}

.print-calculate-hours {
  min-width: 250px;
  margin-right: 1rem;
}

.d-calendar__calendar__container {
  min-width: 100%;
}

.d-calendar__calendar__container.d-calendar__calendar__container--print-mode--is-print-hours {
  min-width: calc(100% - (250px + 1rem));
}

.d-calendar__calendar__container.d-calendar__calendar__container--print-mode:not(.d-calendar__calendar__container--print-mode--is-list) {
  position: relative;
  height: 650px;
}

.input-group__toggle {
  margin-top: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0.5rem 0.25rem;
  cursor: pointer;
  border-radius: 4px;
}

.input-group__toggle:hover {
  background-color: #eeeeee;
}

.input-group__toggle label.d-label {
  font-size: 0.85rem;
  margin-bottom: 0;
  cursor: pointer;
}

.d-modal__print_button__submit {
  padding: 1rem 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.d-modal__print_button__submit.d-modal__print_button__submit--space {
  justify-content: space-between;
}

.custom-select-calendars {
  margin-bottom: 1rem;
}

.custom-select-calendars__submit {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
}

</style>



// WEBPACK FOOTER //
// PrintCalendars.vue?7c3e45ba